let fontSize = null;

export default function rem(pixels) {
  fontSize ||= parseInt(
    getComputedStyle(document.body).getPropertyValue('font-size')
  );

  return pixels / 16.0 * fontSize;
}
